export const ImportFileType = {
  CSV: "csv",

  // SheetJS handles both xls and xlsx so there's no difference
  // between these two formats from the process perspective.
  Excel: "excel",
};
